// Import React Library
import React, {useState} from 'react';

// Import Material UI Accordion
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Import Components
import PaymentMethods from './PaymentMethods';

// Import Icons
import QuizIcon from '@mui/icons-material/Quiz';
import { CiLink } from "react-icons/ci";
import { GoDot } from "react-icons/go";

// Faq Component
const Faq = () => {

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div id='faq' className='faq-section'>
            <h2 className='text-gray-800'>Preguntas Frecuentes <QuizIcon className='faq-icon'/></h2>
            <span></span>

            <div className='faq-container'>
                <Accordion className='acordion-container'  sx={{ boxShadow: 'none', border: 'none' }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <h3 className='text-gray-800'>Entrega Inmediata</h3>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            Estamos comprometidos en brindarte una entrega ágil, asegurando que tus materiales lleguen
                            en perfectas condiciones.
                        </p>
                        <br />
                        <p>
                            <strong>Retiro Estándar:</strong> Retira sin costo en nuestros locales en un plazo de 24 a 48 horas desde la
                            confirmación del pedido.
                        </p>
                        <br />
                        <p>
                            <strong>Retiro Express:</strong> Para pedidos que involucren materiales de stock regular, podemos coordinar la
                            su retiro sin costo, incluso en el mismo día, con al menos 2 horas de anticipación para
                            garantizar la preparación de la carga.
                        </p>
                        <br />
                        <p>
                            <strong>Retiro coordinado con anticipación:</strong> Para productos fabricados a medida el plazo de entrega
                            habitual es hasta 10 días hábiles, según los requerimientos del material solicitado.
                        </p>
                        <br/>
                        <a href="#contactFormTitle" className="group text-gray-500 hover:text-gray-500 flex items-center gap-1">
                            <strong className="font-semibold">
                                Coordina tu envío aquí
                            </strong>
                            <CiLink className="transition-transform duration-300 group-hover:rotate-[360deg]" />
                        </a>
                    </AccordionDetails>
                </Accordion>
                <Accordion className='acordion-container'  sx={{ boxShadow: 'none', border: 'none' }} expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <h3 className='text-gray-800'>Envíos</h3>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            <strong>Envíos Coordinados a Todo el País: </strong>
                            Para tu mayor comodidad, te coordinamos el envío a cualquier punto del país a través de
                            fletes especializados, que aseguran la correcta manipulación y traslado del material para que
                            los productos lleguen a tu obra en óptimas condiciones.
                        </p>
                    </AccordionDetails>
                </Accordion>
                <Accordion className='acordion-container'  sx={{ boxShadow: 'none', border: 'none' }} expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <h3 className='text-gray-800'>Forma de Pago: <span className='lowercase px-2 bg-transparent'>Flexibilidad de opciones</span></h3>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            <strong>
                                Ofrecemos una amplia variedad de opciones de pago para que realices tu proyecto de la
                                forma más cómoda y conveniente para ti:
                            </strong>
                        </p>
                        <br />
                        <p className="flex items-center gap-2 text-gray-800">
                           <GoDot className="text-sm shrink-0" />
                           Transferencia Bancaria.
                        </p>
                        <p className="flex items-center gap-2 text-gray-800">
                            <GoDot className="text-sm shrink-0" />
                            Financiación: Aceptamos todas las tarjetas de crédito y débito bancarias del mercado
                            con hasta 10 Pagos sin Recargo.
                        </p>
                        <br />
                        <PaymentMethods />
                    </AccordionDetails>
                </Accordion>
                <Accordion className='acordion-container'  sx={{ boxShadow: 'none', border: 'none' }} expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <h3 className='text-gray-800'>Servicio de Instalación de Isopaneles: <span className='lowercase px-2 bg-transparent'>Respaldo y Tranquilidad Garantizada</span></h3>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p className="flex items-center gap-2 text-gray-800">
                           <GoDot className="text-sm shrink-0" />
                           Sabemos que la elección del material es tan importante como la calidad de su instalación. Por
                            ello, te brindamos la opción de realizar la colocación con nuestros técnicos para garantizarte la
                            correcta aplicación de los productos y la durabilidad de tu proyecto.
                        </p>
                        <br />
                        <a href="#cotiza" className="group text-gray-500 hover:text-gray-500 flex items-center gap-1">
                            <strong className="font-semibold">
                                Cotizá ahora
                            </strong>
                            <CiLink className="transition-transform duration-300 group-hover:rotate-[360deg]" />
                        </a>
                    </AccordionDetails>
                </Accordion>
                <Accordion className='acordion-container'  sx={{ boxShadow: 'none', border: 'none' }} expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <h3 className='text-gray-800'>Alquiler de Herramientas Especializadas: <span className='lowercase px-2 bg-transparent'>Hazlo tú mismo</span></h3>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p className="flex items-center gap-2 text-gray-800">
                           <GoDot className="text-sm shrink-0" />
                            Te brindamos una asistencia integral con todos los materiales y alquiler de herramientas
                            necesarias, si prefieres realizar tú mismo la instalación.
                        </p>
                        <br/>
                        <a href="#consulta" className="group text-gray-500 hover:text-gray-500 flex items-center gap-1">
                            <strong className="font-semibold">
                                Consulta con nuestro equipo
                            </strong>
                            <CiLink className="transition-transform duration-300 group-hover:rotate-[360deg]" />
                        </a>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
};

// Expor Faq Component
export default Faq;